import { Pipe, PipeTransform } from '@angular/core';
import { WeekIndex } from '../types/menu';
import { getCurrentWeekNumber, getNextWeekNumber } from '../utils/date.utils';

@Pipe({
  name: 'weekNumberByWeekIndex',
})
export class WeekNumberByWeekIndexPipe implements PipeTransform {
  transform(weekIndex: WeekIndex | null): number | null {
    if (weekIndex === null) {
      return null;
    }
    if (weekIndex === WeekIndex.THIS_WEEK) {
      return getCurrentWeekNumber();
    }
    if (weekIndex === WeekIndex.NEXT_WEEK) {
      return getNextWeekNumber();
    }
    return null;
  }
}
